export function MediamarktPrivacyES() {
  return (
    <article>
      <h1>Política de privacidad</h1>
      <time dateTime="2024-09-01">25 de mayo de 2018</time>

      <div>
        <p>
          Esta Política de privacidad se aplica a todos los productos, servicios
          y sitios web ofrecidos por Jotta AS (Jottacloud). Las referencias a
          «nosotros», «nuestro» y «nos» se refieren a Jottacloud, mientras que
          «usted» y «su» se refieren al usuario o cliente de Jottacloud.
        </p>
        <h3>Qué información recopilamos</h3>
        <p>
          Cuando visita los servicios y sitios web de Jottacloud, nos
          proporciona dos tipos de información: Datos personales que usted elige
          revelar conscientemente y que nosotros recopilamos, y la información
          de uso del sitio web, que recabamos a medida que interactúa con
          nuestros servicios.
        </p>
        <h3>Qué información nos proporciona usted</h3>
        <p>
          Cuando usted se registra en Jottacloud, nos proporciona su nombre, su
          dirección de correo electrónico y su número de teléfono (en adelante
          denominados «Datos personales»). Todas las contraseñas de nuestras
          bases de datos están encriptadas. No podemos leer su contraseña.
          Jottacloud no tiene acceso a la información de su tarjeta de crédito.
          Si usted es un/a usuario/a registrado/a de Jottacloud, reconoce y
          acepta que Jottacloud puede enviarle puntualmente comunicaciones
          importantes sobre su cuenta o el Servicio por correo electrónico o
          SMS.
        </p>
        <h3>Información sobre el uso del sitio web</h3>
        <p>
          Cuando accede a Jottacloud, recopilamos su tipo de navegador y
          dirección IP. Obtenemos esta información de absolutamente todos los
          visitantes y usuarios de Jottacloud. En segundo lugar, almacenamos
          cierta información de su navegador mediante «cookies». Una cookie es
          un fragmento de datos, almacenado en el ordenador del usuario, que
          contiene información sobre el mismo.
        </p>
        <p>
          Utilizamos cookies de identificación de sesión para confirmar que los
          usuarios registrados han iniciado sesión. También utilizamos cookies
          persistentes para almacenar información sobre el uso del sitio web.
          Las cookies persistentes se almacenan en su equipo durante un período
          de tiempo más largo, pero esta información no permite identificarle de
          forma personal.
        </p>
        <h3>Transmisiones de datos</h3>
        <p>
          Cuando sube o carga archivos a Jottacloud, también envía información
          del sistema de archivos, incluyendo nombres de archivos y directorios.
          Durante su transferencia, los archivos se cifran con Secure Socket
          Layer (SSL).
        </p>
        <h3>Cómo utilizamos la información</h3>
        <ul>
          <li>
            Utilizamos la información que recopilamos con el fin de proporcionar
            a los usuarios servicios de la mayor calidad, así como para
            desarrollar nuevos productos y servicios para nuestros clientes, de
            facto y potenciales.
          </li>
          <li>
            A la hora de proporcionarle asistencia técnica, podemos ver los
            metadatos de su sistema de archivos (nombre de los archivos, tamaño,
            etc.) pero no así el contenido de los mismos.
          </li>
          <li>
            No vendemos ni comercializamos su dirección de correo electrónico
          </li>
          <li>No revelamos sus Datos personales a terceros.</li>
          <li>No vemos los archivos que sube a Jottacloud.</li>
        </ul>
        <h3>Niños menores de 13 años</h3>
        <p>
          Los niños menores de 13 años no pueden registrarse en Jottacloud.
          Jottacloud no recopila ni solicita deliberadamente Datos personales de
          ninguna persona menor de 13 años, ni permite intencionalmente que
          dichas personas se registren.
        </p>
        <h3>Seguridad</h3>
        <p>
          Utilizamos medidas de seguridad estándar de la industria para
          protegernos y protegerle contra la pérdida, mal uso y alteración de la
          información bajo nuestro control. Debido a que el correo electrónico y
          la mensajería instantánea no se reconocen como comunicaciones seguras,
          le solicitamos que no nos comunique Datos personales confidenciales
          por correo electrónico o servicios de mensajería instantánea. Si
          cancela su cuenta, podemos conservar sus datos y otro tipo de
          información en nuestro archivo o registro de respaldo hasta que se
          eliminen tras 90 días.
        </p>
        <h3>Enlaces</h3>
        <p>
          Jottacloud puede contener enlaces a otras páginas web, de cuyas
          prácticas de privacidad y seguridad no somos responsables. Esta
          Política de privacidad se aplica únicamente a la información
          recopilada por Jottacloud.
        </p>
        <h3>Acceso, modificación y eliminación de Datos personales</h3>
        <p>
          Tiene derecho a solicitar el acceso, la corrección o la eliminación de
          los Datos personales que procesamos. También tiene derecho a exigir la
          limitación del tratamiento, a oponerse al mismo y a reclamar el
          derecho a la portabilidad de los datos. Puede retirar su
          consentimiento para el procesamiento de Datos personales en cualquier
          momento. Puede encontrar más información sobre el contenido de estos
          derechos en la página web del Comité de Inspección de Datos:{' '}
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          . Necesitamos su consentimiento para almacenar Datos personales a fin
          de poder utilizar nuestros servicios.
        </p>
        <h3>Quejas</h3>
        <p>
          Si considera que nuestro procesamiento de Datos personales no coincide
          con lo que hemos descrito aquí o que podríamos estar violando las
          leyes de privacidad de otra forma, puede apelar ante el Comité de
          Inspección de Datos. Para obtener información sobre cómo ponerse en
          contacto con el Comité de Inspección de Datos, visite su página web:{' '}
          <a
            href="https://www.datatilsynet.no"
            rel="nofollow noopener noreferrer"
            target="_blank"
          >
            https://www.datatilsynet.no
          </a>
          .
        </p>
        <h3>Cambios a esta Política</h3>
        <p>
          Jottacloud se reserva el derecho, a su entera discreción, de revisar,
          enmendar o modificar esta Política en cualquier momento. Cualquier
          revisión, enmienda o modificación de esta Política se notificará en
          los sitios web de Jottacloud, y el uso continuo del Servicio por parte
          del Usuario significará la aceptación de dichos cambios. Las
          notificaciones de los cambios anteriormente indicados se comunicarán
          al usuario por correo electrónico.
        </p>
      </div>
    </article>
  )
}
